import React, { FC, useEffect, useState } from "react";
import Input from "shared/Input/Input";
import CommonLayout from "./CommonLayout";
import FormItem from "./FormItem";
import { useLocation, useNavigate } from "react-router-dom";
import Textarea from "shared/Textarea/Textarea";
import api from '../../api';
import { connect, useDispatch } from "react-redux";
import { logout, updateUser } from "../../redux/reducers/userReducer";
import MultiSelectDropdown from "../../shared/MultiSelectDropdown";

const PageCreateBrand = ({user}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const nextHref = `/`;
  
  const savedFormData = location.state?.formData;
  const existingBrand = location.state?.brand;

  const initialValues = {
    brandowner_id: user?.company?.id ?? 0,
    name: savedFormData?.name || '',
    description: savedFormData?.description || '',
    categories: savedFormData?.categories || [],
  }
  
  const [inputValues, setInputValues] = useState(initialValues);
  const [isOptionsLoaded, setOptionsLoaded] = useState(false);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState(
    savedFormData?.categories?.map(cat => ({
      label: cat.name,
      value: cat.id
    })) || []
  );
  
  const dispatch = useDispatch();
  
  useEffect(() => {
    if (savedFormData) {
      setInputValues({
        brandowner_id: user?.company?.id ?? 0,
        name: savedFormData.name || '',
        description: savedFormData.description || '',
        categories: savedFormData.categories || [],
      });
      
      setSelectedCategories(
        savedFormData.categories?.map(cat => ({
          label: cat.name,
          value: cat.id
        })) || []
      );
    }
  }, [location.state, savedFormData]);
  
  const handleInputChange = (e) => {
    setInputValues((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };
  
  useEffect(() => {
    if(!isOptionsLoaded) {
      api.getProductGroups((res) => {
        const formattedOptions = res.data.map(item => ({
          label: item.name,
          value: item.id
        }));
        setCategoryOptions(formattedOptions);
        setOptionsLoaded(true);
      });
    }
  }, []);
  
  useEffect(() => {
    setInputValues((prevState) => ({
      ...prevState,
      brandowner_id: user?.company?.id ?? 0,
    }));
  }, [user]);
  
  const handleCategoryChange = (selected) => {
    setSelectedCategories(selected);
    setInputValues((prevState) => ({
      ...prevState,
      categories: selected.map(item => ({
        id: item.value,
        name: item.label
      }))
    }));
  };
  
  const handleCreateBrand = () => {
    if (existingBrand) {
      navigate('/brand/images', {
        state: {
          brand: existingBrand,
          formData: inputValues
        }
      });
    } else {
      api.createBrand(inputValues, (res) => {
        console.log(res.data);
        const brandWithImages = {
          ...res.data,
          images: [] 
        };

        const updatedUser = {
          ...user,
          company: {
            ...user.company,
            brands: [...(user.company.brands || []), brandWithImages]
          }
        };
        
        dispatch(updateUser(updatedUser));
        navigate('/brand/images', { 
          state: { 
            brand: res.data,
            formData: inputValues 
          } 
        });
      });
    }
  }
  
  return (
    <CommonLayout
      index="01"
      maxIndex={'2'}
      backtHref="/register"
      nextHref={nextHref}
      onSubmit={handleCreateBrand}
      hideBackButton={true}
    >
      <>
        <h2 className="text-2xl font-semibold">Brand Details</h2>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        {/* FORM */}
        <div className="space-y-8">
          <FormItem
            label="Brand Name"
          >
            <Input 
              placeholder="Brand name"
              name='name'
              value={inputValues.name}
              onChange={handleInputChange}
            />
          </FormItem>
          {/* ITEM */}
          <FormItem
            label="Product Groups"
          >
            <MultiSelectDropdown
              options={categoryOptions}
              value={selectedCategories}
              onChange={handleCategoryChange}
            />
          </FormItem>
          <>
            <div>
              <h2 className="text-2xl font-semibold">
                {/* About the Brand */}
                About Brand Profile
              </h2>
            </div>

            <Textarea 
              // placeholder="..."  
              rows={14}
              name='description'
              value={inputValues.description}
              onChange={handleInputChange} />
          </>
        </div>
      </>
    </CommonLayout>
  );
};

const mapStateToProps = (state) => ({
  user: state.user.user,
});

export default connect(mapStateToProps, { updateUser, logout })(
  PageCreateBrand
);
